import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getFourDCollection = () => async dispatch => {
      dispatch({
            type: actionTypes.FOURD_COLLECTION_REQUEST,
      });
      await axios.get("/fourDCollections/last/all")
            .then(response => {
                  dispatch({
                        type: actionTypes.FOURD_COLLECTION_SUCCESS,
                        payload: response.data
                  })
            })
            .catch(error => {
                  dispatch({
                        type: actionTypes.FOURD_COLLECTION_FAIL,
                        payload: getMessage(error)
                  })
            })
}